<template>
  <div
    :class="[
      'filter-tab-component-container',
      { active: flashcardStatusFilter.id == status.id },
      `${status.name || ''}`
    ]"
    @click="changeFilter(status)"
  >
    <icon
      :name="iconName"
      class="icon"
    ></icon>
    <span class="text-xs text-primary display-name">
      {{ displayName }}
    </span>
    <span class="text-xs text-tertiary counter">{{ count }}</span>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';

export default {
  components: {
    Icon,
  },
  props: {
    status: {
      type: Object,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    displayName() {
      if (this.status.name === 'unanswered' && this.status.displayName === '') {
        return 'Unanswered';
      }
      return this.status.displayName;
    },
    flashcardStatusFilter() {
      return this.$store.getters['flashcardStatuses/flashcardStatusFilter'];
    },
    iconName() {
      if (this.status.name === 'bookmarked') {
        return 'bookmark-icon';
      }
      return `tag-${this.status.name}`;
    },
  },
  methods: {
    changeFilter(status) {
      this.$store.commit('flashcardStatuses/setFlashcardStatusFilter', status.id);
      this.$analytics.events.selectedFilter(status.displayName);
    },
  },
};
</script>

<style lang='scss' scoped>
  .filter-tab-component-container {
    text-align: center;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 0;
    border-radius: var(--radius-md);
    border: 1px solid var(--border-primary);
    background-color: white;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    box-shadow: 0px -2px 0px 0px rgba(16, 24, 40, 0.05) inset;
    box-shadow: 0px 0px 0px 1px rgba(16, 24, 40, 0.18) inset;
    font-weight: var(--Fontweightfont-weight-medium);
    box-sizing: border-box;
    transition: none !important;
    cursor: pointer;

    &.active {
      border: 1px solid var(--button-tertiary-fg);
      box-shadow: 0 0 0 1px var(--button-tertiary-fg);
      font-weight: var(--Fontweightfont-weight-semibold);
    }

    .display-name {
      display: none;

      @include breakpoint(desktop) {
        display: block;
      }
    }

    .icon {
      height: 12.5px;
    }

    @include breakpoint(desktop) {
      flex-direction: row;
      flex: unset;
      padding: 8px 16px;
    }

    .counter {
      background-color: var(--bg-light);
      padding: var(--spacing-xxs) var(--spacing-md);
      border-radius: var(--radius-full);
      border: 1px solid var(--utility-gray-200);
    }
  }
</style>
